const PagePermissions = {
  edit: 'page:edit',
  create: 'page:create',
  delete: 'page:delete',
  view: 'page:view',
}

export default PagePermissions
